const clientExtensionBridge = require("../shim/clientExtensionBridge.js");
export const HAS_ALL = 0;
export const HAS_MELEE_ONLY = 1;
export const HAS_PRIMARY_OR_SECONDARY = 2;
export const HAS_MELEE_AS_PRIMARY_AND_SECONDARY = 3;
const config = require("../config.js");
const vO457 = {
  min: 80,
  max: 160,
  vh: 0.25
};
const vO458 = {
  min: 30,
  max: 100,
  vw: 0.04
};
const vO459 = {
  min: 20,
  max: 60,
  vw: 0.037
};
const vO460 = {
  min: 40,
  max: 120,
  vw: 0.05
};
const vO461 = {
  min: 40,
  max: 80,
  vh: 0.046
};
const vO462 = {
  min: 10,
  max: 60,
  vw: 0.03
};
const vO463 = {
  min: 10,
  max: 60,
  vh: 0.037
};
const vVO463 = vO463;
const vO464 = {
  min: 10,
  max: 40,
  vw: 0.03
};
const vLN2210 = 22;
const vO465 = {
  JOY: "mobileJoystick",
  SHOOT: "mobileShoot",
  AIM_SHOOT: "mobileAimShoot",
  SCOPE: "mobileScope",
  RELOAD: "mobileReload",
  MELEE: "mobileKSwap",
  CROUCH: "mobileCrouch",
  JUMP: "mobileJump",
  SWAP: "mobileSwap"
};
var v13895;
var v13896;
var v13897;
var v13898;
var v13899;
export function init(p17827, p17828, p17829) {
  v13896 = p17827;
  v13897 = p17828;
  v13895 = p17829;
}
export function onResize() {
  createOrRecreateJoystick();
  f2150();
  f2149();
}
function f2149() {
  let vIii25 = f2157(vO459);
  let vIii26 = f2157(vO458);
  let vIii27 = f2157(vO457);
  let vIii28 = f2157(vO462);
  let v13900 = vIii27 / 2;
  let vO466 = {
    x: vIii26 + v13900,
    y: vIii25 + v13900
  };
  f2153(v13899, {
    left: vO466.x,
    bottom: vO466.y
  });
  let v13901 = mobileScope.getBoundingClientRect().width / 2;
  let vO467 = {
    x: vIii28 + v13901
  };
  let v13902 = v13901 + v13900 + vLN2210;
  let v13903 = vO466.x - vO467.x;
  let v13904 = Math.sqrt(v13902 * v13902 - v13903 * v13903);
  vO467.y = v13904 + vO466.y;
  f2153(mobileScope, {
    left: vIii28,
    bottom: vO467.y - v13901
  });
}
function f2150() {
  let vIii29 = f2157(vO461);
  let vIii30 = f2157(vO460);
  let vIii31 = f2157(vO463);
  let vIii32 = f2157(vVO463);
  let vIii33 = f2157(vO464);
  if (window.spectating) {
    f2154(mobileShoot, mobileAimShoot, mobileReload, mobileKSwap, mobileScope, mobileSwap, mobileCrouch, mobileJump);
    return;
  }
  f2155(mobileShoot, mobileAimShoot, mobileReload, mobileKSwap, mobileScope, mobileSwap, mobileCrouch, mobileJump);
  f2153(mobileShoot, {
    right: vIii30,
    bottom: vIii29
  });
  f2153(mobileAimShoot, {
    right: vIii30,
    bottom: vIii29
  });
  updateScopeStatus();
  let v13905 = mobileScope.getBoundingClientRect().width / 2;
  let vO468 = {
    x: v13905 + vIii30,
    y: v13905 + vIii29
  };
  let v13906 = mobileReload.getBoundingClientRect().width / 2;
  let vO469 = {
    y: vIii31 + v13906
  };
  let v13907 = v13906 + v13905 + vLN2210;
  let v13908 = vO468.y - vO469.y;
  let v13909 = Math.sqrt(v13907 * v13907 - v13908 * v13908);
  vO469.x = v13909 + vO468.x;
  f2153(mobileReload, {
    right: vO469.x - v13906,
    bottom: vIii31
  });
  f2153(mobileKSwap, {
    right: vO469.x + v13906 + vLN2210,
    bottom: vIii32
  });
  let v13910 = mobileCrouch.getBoundingClientRect().width / 2;
  let vO470 = {
    x: vIii33 + v13910
  };
  let v13911 = v13910 + v13905 + vLN2210;
  let v13912 = vO468.x - vO470.x;
  let v13913 = Math.sqrt(v13911 * v13911 - v13912 * v13912);
  vO470.y = v13913 + vO468.y;
  f2153(mobileCrouch, {
    right: vIii33,
    bottom: vO470.y - v13910
  });
  f2153(mobileJump, {
    right: vIii33,
    bottom: vO470.y + v13910 + vLN2210
  });
  let v13914 = mobileJump.getBoundingClientRect();
  let v13915 = mobileJump.getBoundingClientRect().width;
  f2153(mobileSwap, {
    right: vIii33 - 8,
    top: v13914.y - 16 - v13915
  });
  let vObject2 = Object(clientExtensionBridge.a)();
  if (vObject2 && vObject2.Game && vObject2.Game.mode) {
    let vIii34 = f2156(vObject2);
    if (vIii34 !== HAS_ALL) {
      if (vIii34 === HAS_MELEE_ONLY) {
        f2154(mobileAimShoot, mobileScope, mobileReload, mobileKSwap, mobileSwap);
      } else if (vIii34 === HAS_PRIMARY_OR_SECONDARY || vIii34 === HAS_MELEE_AS_PRIMARY_AND_SECONDARY) {
        f2154(mobileSwap);
      }
    }
  }
}
export function createOrRecreateJoystick() {
  if (v13898) {
    v13898.destroy();
  }
  v13898 = nipplejs.create({
    zone: mobileJoystick,
    size: 120,
    multitouch: undefined,
    mode: "static",
    color: "black"
  });
  v13898.on("move", v13896);
  v13898.on("end", v13897);
}
export function updateScopeStatus() {
  let vV13895 = v13895();
  const v13916 = f2156(Object(clientExtensionBridge.a)()) == HAS_MELEE_ONLY;
  mobileShoot.classList.toggle("hidden", !vV13895 && !v13916);
  mobileAimShoot.classList.toggle("hidden", !!vV13895);
}
function f2153(p17830, p17831) {
  ["left", "top", "right", "bottom"].forEach(function (p17832) {
    p17830.style[p17832] = p17831[p17832] || p17831[p17832] == 0 ? p17831[p17832] + "px" : "unset";
  });
}
function f2154() {
  for (var v13917 in arguments) {
    arguments[v13917].style.display = "none";
  }
}
function f2155() {
  for (var v13918 in arguments) {
    if (arguments[v13918].style.display == "none") {
      arguments[v13918].style.display = "";
    }
  }
}
function f2156(p17833) {
  if (!p17833) {
    return HAS_ALL;
  }
  let v13919 = p17833.loadout.classIndex;
  let v13920 = p17833.Game.classConfig[v13919];
  let v13921 = v13920.loadout[0];
  let v13922 = p17833.Game.weaponConfig[v13921];
  let v13923 = !v13922.melee && !v13922.secondary;
  let v13924 = v13920.secondary || v13922.secondary;
  if (v13921 && v13921 === 12) {
    if (v13924) {
      return HAS_MELEE_AS_PRIMARY_AND_SECONDARY;
    } else {
      return HAS_MELEE_ONLY;
    }
  }
  if (v13923 && !v13924 || !v13923 && v13924) {
    return HAS_PRIMARY_OR_SECONDARY;
  } else {
    return HAS_ALL;
  }
}
function f2157(p17834) {
  let vLN99999 = 99999;
  if (p17834.vw) {
    vLN99999 = window.innerWidth * p17834.vw;
  }
  if (p17834.vh) {
    vLN99999 = Math.min(vLN99999, window.innerHeight * p17834.vh);
  }
  return Math.max(p17834.min, Math.min(p17834.max, vLN99999));
}
function f2158() {}